import {FC, Suspense, lazy, useEffect} from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";
import { getCSSVariableValue } from "../../_metronic/assets/ts/_utils";
import { WithChildren } from "../../_metronic/helpers";
import { MasterLayout } from "../../_metronic/layout/MasterLayout";
import { KEY_LOCALSTORAGE } from "../modules/auth/core/_consts";
import { localStorageItem } from "../modules/utils/LocalStorage";
import { HomePage } from "../pages/Homepage/HomePage";
import { DashboardWrapper } from "../pages/dashboard/DashboardWrapper";
import BuildPlans from "../modules/build-plan/BuildPlans";
import CriteriaPage from "../modules/criteria/CriteriaPage";
import DanhMuc from "../modules/danh-muc/DanhMuc";
import {ROUTES_PATH} from "../modules/utils/Constant";
import ReportAssignment from "../modules/report-assignment/ReportAssignment";
import CorrectiveSubsection from "../modules/CorrectiveSubsection/CorrectiveSubsection";
import ReportEvaluation from "../modules/report-evaluation/ReportEvaluation";


const PrivateRoutes = () => {
  const qlclMenu = localStorageItem.get(KEY_LOCALSTORAGE.ID_TOKEN_DECODE)?.["menus"]?.["oceantech-qlcl-server"] || [];
  const listMenu = qlclMenu[0]?.subs || [];
  const menusByPermission = [...listMenu];
  const WizardsPage = lazy(() => import("../modules/wizards/WizardsPage"));
  const navigate = useNavigate();

  useEffect(() => {
    if (!menusByPermission?.length) {
      console.log(menusByPermission)
      navigate("/error/403");
    } else {
      // navigate(`${menusByPermission?.[0]?.uri}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menusByPermission?.length])
  return (
    <Routes>
      <Route index element={<Navigate to={`/build-plan`} />} />
      <Route path="/*" element={<Navigate to={`/build-plan`} />} />
      {/* <Route path="/*" element={<HomePage />} /> */}
      {/* <Route index element={<Navigate to="/home" />} */}
      <Route path="home" element={<HomePage />} />
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path="auth/*" element={<Navigate to="/home" />} />
        {/* Pages */}
        <Route path={ROUTES_PATH.DASHBOARD} element={<DashboardWrapper />} />
        <Route path={ROUTES_PATH.BUILD_PLAN} element={<BuildPlans />} />
        <Route path={ROUTES_PATH.REPORT_ASSIGNMENT} element={<ReportAssignment />} />
        <Route path={ROUTES_PATH.CRITERIA} element={<CriteriaPage />} />
        <Route path={ROUTES_PATH.CRITERIA_REPORT} element={<CriteriaPage />} />
        <Route path={ROUTES_PATH.EVALUATION_REPORT} element={<ReportEvaluation />} />
        <Route path={ROUTES_PATH.CORRECTIVE_SUBSECTION} element={<CorrectiveSubsection />} />
        <Route path={ROUTES_PATH.CATEGORIES} element={<DanhMuc />} />

        {/* Lazy Modules */}
        <Route path="crafted/pages/profile/*" element={<SuspensedView></SuspensedView>} />
        <Route
          path="crafted/pages/wizards/*"
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path="*" element={<Navigate to="/error/404" />} />
      </Route>
    </Routes>
  );
};

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue("--kt-primary");
  TopBarProgress.config({
    barColors: {
      "0": baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  });
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};

export { PrivateRoutes };

